export default __webpack_public_path__ + "static/media/6.7d7d307e.jpg";